'use strict';

const $ = window.jQuery;

export default class Testimonies {
    constructor() {
        $('.testimonies__slider').slick({
            rows: 0,
            slidesToShow: 1,
            infinite: true,
            arrows: false,
            dots: true,
            accessibility: true,
            swipeToSlide: true,
            autoplay: true,
            autoplaySpeed: 5000
        })
    }
}
